import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import qs from 'query-string';
import moment from 'moment';
import qsFilters from 'qs';

// Libs
import {
  thunkHandler,
  thunkErrorHanlder,
  parseUrl,
  filterCustomers,
  renameKeys,
  parseSpecialCustomerCharacters,
  Consequence
} from '../../libs/utils';

// Constants
import {
  CUSTOMER_BASE,
  CUSTOMER_DEBT,
  CUSTOMER_SINGLE,
  CUSTOMER_INVOICES,
  CUSTOMER_PAYMENTS,
  ACCOUNT_STATEMENT,
  GET_ALL_PRODUCTS,
  CUSTOMER_EXPORT,
  CUSTOMER_CONTRACTS,
  ACCOUNT_STATEMENT_SMS,
  CUSTOMER_IMPORT,
  INVOICE_BASE,
  PAYMENT_BASE,
  CONTRACT_BASE,
  CREDIT_NOTE_BASE,
  CUSTOMER_ACTIVITY,
  CUSTOMER_NOTES,
  CUSTOMER_REMINDERS,
  CUSTOMER_TAXES,
  CUSTOMER_RELATION,
  CUSTOMER_RELATION_BASE,
  CUSTOMER_RELATION_BYID,
  BRANCH_ASSIGNMENT_IMPORT,
  ACCOUNT_STATEMENT_WP
} from '../../constants/endpoints';

import { getPackagesStats } from '../actions/permsActions';
import { NEW_STATS, NEW_VALUES } from './invoiceActions';
import { NEW_STATS_CONTRACTS, NEW_VALUES_CONTRACTS } from './contractActions';
import { NEW_STATS_PAYMENTS, NEW_VALUES_PAYMENTS } from './paymentActions';

export const NEW_SINGLE_CUSTOMER = 'NEW_SINGLE_CUSTOMER';
export const NEW_CUSTOMERS = 'NEW_CUSTOMERS';
export const NEW_ALL_CUSTOMERS = 'NEW_ALL_CUSTOMERS';
export const NEW_CUSTOMER_INVOICES = 'NEW_CUSTOMER_INVOICES';
export const NEW_CUSTOMER_PAYMENTS = 'NEW_CUSTOMER_PAYMENTS';
export const NEW_CUSTOMER_CONTRACTS = 'NEW_CUSTOMER_CONTRACTS';
export const NEW_ACCOUNT_STATEMENT = 'NEW_ACCOUNT_STATEMENT';
export const NEW_ACCOUNT_STATEMENT_SMS = 'NEW_ACCOUNT_STATEMENT_SMS';
export const NEW_CUSTOMER_PRODUCTS = 'NEW_CUSTOMER_PRODUCTS';
export const NEW_CUSTOMERS_DEBT = 'NEW_CUSTOMERS_DEBT';
export const NEW_CUSTOMER_UNPAID_INVOICES = 'NEW_CUSTOMER_UNPAID_INVOICES';
export const NEW_EXPORT_CUSTOMERS = 'NEW_EXPORT_CUSTOMERS';
export const NEW_IMPORT_CLIENTS = 'NEW_IMPORT_CLIENTS';
export const ADD_CUSTOMER_PRODUCT = 'ADD_CUSTOMER_PRODUCT';
export const EDIT_CUSTOMER_PRODUCT = 'EDIT_CUSTOMER_PRODUCT';
export const NEW_CUSTOMER_ACTIVITY = 'NEW_CUSTOMER_ACTIVITY';
export const NEW_CUSTOMER_INVOICES_FILTERS = 'NEW_CUSTOMER_INVOICES_FILTERS';
export const NEW_CUSTOMER_PAYMENTS_FILTERS = 'NEW_CUSTOMER_PAYMENTS_FILTERS';
export const NEW_CUSTOMER_CONTRACTS_FILTERS = 'NEW_CUSTOMER_CONTRACTS_FILTERS';
export const NEW_CUSTOMER_CREDIT_NOTES_FILTERS = 'NEW_CUSTOMER_CREDIT_NOTES_FILTERS';
export const NEW_CUSTOMER_CREDIT_NOTES = 'NEW_CUSTOMER_CREDIT_NOTES';
export const NEW_LOADING_TABLE = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING = 'NEW_SEARCHING';
export const NEW_CUSTOMER_NOTES = 'NEW_CUSTOMER_NOTES';
export const NEW_CUSTOMER_NOTES_FILTERS = 'NEW_CUSTOMER_NOTES_FILTERS';
export const NEW_CUSTOMER_REMINDERS = 'NEW_CUSTOMER_REMINDERS';
export const NEW_CUSTOMER_REMINDERS_FILTERS = 'NEW_CUSTOMER_REMINDERS_FILTERS';
export const NEW_CUSTOMER_TAXES = 'NEW_CUSTOMER_TAXES';
export const CUSTOMER_SUCURSAL_BYID = 'CUSTOMER_SUCURSAL_BYID';
export const CUSTOMER_SUCURSAL_BASE = 'CUSTOMER_SUCURSAL_BASE';
export const CUSTOMER_SUCURSAL_ALL = 'CUSTOMER_SUCURSAL_ALL';
export const NEW_CUSTOMER_SUCURSAL = 'NEW_CUSTOMER_SUCURSAL';
export const DELETE_CUSTOMER_SUCURSAL = 'DELETE_CUSTOMER_SUCURSAL';
export const UPDATE_CUSTOMER_SUCURSAL = 'UPDATE_CUSTOMER_SUCURSAL';
export function sendAccountStatement(body, isUnlimited) {
  return dispatch =>
    axios
      .post(ACCOUNT_STATEMENT, body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_ACCOUNT_STATEMENT, 'ERROR'))
      .then(() => {
        if (!isUnlimited) {
          dispatch(getPackagesStats());
        }
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END sendAccountStatement

export function sendAccountStatementSms(body, isUnlimited) {
  return dispatch =>
    axios
      .post(ACCOUNT_STATEMENT_SMS, body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_ACCOUNT_STATEMENT, 'ERROR'))
      .then(() => {
        if (!isUnlimited) {
          dispatch(getPackagesStats());
        }
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END sendAccountStatement

export function sendAccountStatementWatsApp(body, isUnlimited) {
  return dispatch =>
    axios
      .post(ACCOUNT_STATEMENT_WP, body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_ACCOUNT_STATEMENT, 'ERROR'))
      .then(() => {
        if (!isUnlimited) {
          dispatch(getPackagesStats());
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          return error.response.data;
        }
      });
} // END sendAccountStatement

export function getCustomerPayments(uuid, params) {
  const page = get(params, 'page', 1);

  return dispatch =>
    axios
      .get(parseUrl(CUSTOMER_PAYMENTS, { uuid }), page)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CUSTOMER_PAYMENTS, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getCustomerPayments

export function getCustomerContracts(uuid, params) {
  const page = get(params, 'page', 1);

  return dispatch =>
    axios
      .get(parseUrl(CUSTOMER_CONTRACTS, { uuid }), page)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CUSTOMER_CONTRACTS, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getCustomerPayments

export function getCustomerInvoices(uuid, params) {
  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};

  if (params.filter) qsObj.filter = params.filter;
  //if (!!params.page) qsObj.page = params.page;
  if (params.created) qsObj.created = params.created;
  if (params.start) qsObj.start = params.start;
  if (params.end) qsObj.end = params.end;
  if (params.cancel) qsObj.cancel = params.cancel;

  return dispatch =>
    axios
      .get(parseUrl(CUSTOMER_INVOICES, { uuid }, params))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CUSTOMER_INVOICES, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getCustomerInvoices

export function getCustomerInvoicesV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CUSTOMER_INVOICES, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

/**
 * Obtiene las facturas por pagar de un determinado cliente
 * @param {string}   uuid Identificador del cliente
 * @param {number}   page Número de pagina a consultar
 * @param {array}   prevData Array de datos previos para concatenar
 * @return {function}     acción de redux
 */
export function getCustomerUnpaidInvoices(uuid, page = 1, prevData = []) {
  return dispatch =>
    axios
      .get(parseUrl(CUSTOMER_INVOICES, { uuid }, { filter: 'to_pay', opt: 1, page }))
      .then(res => {
        let filteredData = { ...get(res, 'data', {}), data: [...prevData, ...get(res, 'data.data')] };
        return thunkHandler(dispatch, filteredData, NEW_CUSTOMER_UNPAID_INVOICES, 'ERROR', res);
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getCustomerUnpaidInvoices

export function setCustomerUnpaidInvoices(invoices = []) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_UNPAID_INVOICES,
        payload: { data: invoices }
      })
    );
} // END setCustomerUnpaidInvoices

export function resetCustomerUnpaidInvoices() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_UNPAID_INVOICES,
        payload: []
      })
    );
} // END tableProducts

let timeout;
export function getCustomers(params) {
  clearTimeout(timeout);
  return new Promise(resolve => {
    timeout = setTimeout(() => {
      if (typeof params !== 'object' && !Array.isArray(params)) params = {};
      const qsObj = {};
      const { activeTab, page, search, startDate, endDate, sort } = params;
      const filterTab = filterCustomers(activeTab);

      if (activeTab && filterTab === 0) qsObj.valid = filterTab;
      if (page) qsObj.page = page;
      if (search) qsObj.q = search;
      if (activeTab && filterTab === true) qsObj.due = filterTab;
      if (sort) qsObj.sort = sort;
      if (startDate) {
        qsObj.start = startDate;
        if (endDate) qsObj.end = endDate;
        else qsObj.end = moment().format('YYYY-MM-DD');
      }

      return resolve(dispatch =>
        axios
          .get(`${CUSTOMER_BASE}?${qs.stringify(qsObj)}`)
          .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CUSTOMERS, 'ERROR', res))
          .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
      );
    }, 800);
  });
} // END getCustomers

export function exportCustomers(params = {}) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, search, startDate, endDate } = params;
  const filterTab = filterCustomers(activeTab);

  if (activeTab && filterTab === 0) qsObj.valid = filterTab;
  if (page) qsObj.page = page;
  if (search) qsObj.q = search;
  if (activeTab && filterTab === true) qsObj.due = filterTab;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if

  return dispatch =>
    axios
      .get(`${CUSTOMER_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_CUSTOMERS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function getCustomersWithDebt() {
  return dispatch =>
    axios.get(CUSTOMER_DEBT).then(res => {
      const { pages } = res.data;
      const customersPageEndpoints = [];

      for (let i = 1; i <= pages; i++) {
        if (i <= pages) customersPageEndpoints.push(`${CUSTOMER_DEBT}&page=${i}`);
      }
      return Promise.all(customersPageEndpoints.map(page => axios.get(page)))
        .then(customerPages => {
          let allCustomersWithDebt = [];
          customerPages.forEach(customerPage => {
            allCustomersWithDebt = [...allCustomersWithDebt, ...customerPage.data.data];
          });
          return Promise.resolve(allCustomersWithDebt);
        })
        .then(response => {
          const newKeys = { name: 'label' },
            customersWithLabel = response.map(customer => {
              customer.legal_name = parseSpecialCustomerCharacters(customer.legal_name);
              customer.name = parseSpecialCustomerCharacters(customer.name);
              customer.value = customer.uuid;
              const renamedObj = renameKeys(customer, newKeys);
              return renamedObj;
            });
          thunkHandler(dispatch, customersWithLabel, NEW_CUSTOMERS_DEBT, 'ERROR');
        })
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
    });
} // END getCustomersWithDebt

export function getAllCustomers() {
  return dispatch =>
    axios.get(CUSTOMER_BASE).then(res => {
      const { pages } = res.data;
      const customersPageEndpoints = [];

      for (let i = 1; i <= pages; i++) {
        if (i <= pages) customersPageEndpoints.push(`${CUSTOMER_BASE}/?page=${i}`);
      }
      return Promise.all(customersPageEndpoints.map(page => axios.get(page)))
        .then(customerPages => {
          let allCustomers = [];
          customerPages.forEach(customerPage => {
            allCustomers = [...allCustomers, ...customerPage.data.data];
          });
          return Promise.resolve(allCustomers);
        })
        .then(response => {
          const newKeys = { name: 'label', uuid: 'value' };
          const customerOptions = response.map(customer => {
            customer.legal_name = parseSpecialCustomerCharacters(customer.legal_name);
            customer.name = parseSpecialCustomerCharacters(customer.name);
            const renamedObj = renameKeys(customer, newKeys);
            return renamedObj;
          });
          return thunkHandler(dispatch, customerOptions, NEW_ALL_CUSTOMERS, 'ERROR');
        })
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
    });
}

export function getSingleCustomer(uuid) {
  return dispatch =>
    axios.get(parseUrl(CUSTOMER_SINGLE, { uuid })).then(res => {
      const customer = get(res, 'data.data');
      return thunkHandler(dispatch, customer, NEW_SINGLE_CUSTOMER, 'ERROR');
    });
} // END getSingleCustomer

export function updateCustomerEditingForm(uuid, values) {
  return dispatch =>
    axios
      .put(parseUrl(CUSTOMER_SINGLE, { uuid }), values)
      .then(res  => new Consequence({
        dispatch,
        payload: { data: get(res, 'data.data', {}) },
        eventTypes: { success: NEW_SINGLE_CUSTOMER, error: 'ERROR' }
      }))
}

export function updateCustomer(uuid, values) {
  return dispatch =>
    axios
      .put(parseUrl(CUSTOMER_SINGLE, { uuid }), values)
      .then(() => {
        // thunkHandler(dispatch, get(res, 'data.data'), NEW_SINGLE_CUSTOMER, 'ERROR')
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END updateCustomer

export function getAllCustomerProducts() {
  function productsOptions(products) {
    const addProductOption = { description: 'Agregar nuevo producto' },
      newKeys = { description: 'label' };
    let clonedProducts = [addProductOption, ...products];

    return clonedProducts.map((product, index) => {
      product.value = index + 1;
      const renamedObj = renameKeys(product, newKeys);
      return renamedObj;
    });
  } // END productsOptions

  return dispatch =>
    axios
      .get(GET_ALL_PRODUCTS)
      .then(res => {
        return thunkHandler(dispatch, productsOptions(get(res, 'data.data')), NEW_CUSTOMER_PRODUCTS, 'ERROR');
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getAllCustomerProducts

export function addCustomerProduct(payload) {
  const newKeys = { description: 'label' };
  const renamedObj = renameKeys(payload, newKeys);

  return dispatch =>
    Promise.resolve(
      dispatch({
        type: ADD_CUSTOMER_PRODUCT,
        payload: renamedObj
      })
    );
} // END addCustomerProduct

export function editCustomerProduct(payload, products = []) {
  const newKeys = { description: 'label' };
  const newProducts = products.map(product => {
    if (get(payload, 'uuid') === get(product, 'uuid')) {
      const renamedObj = renameKeys(payload, newKeys);
      return { ...product, ...renamedObj };
    }

    return product;
  });

  return dispatch =>
    Promise.resolve(
      dispatch({
        type: EDIT_CUSTOMER_PRODUCT,
        payload: newProducts
      })
    );
} // END products

export function importCustomers(payload) {
  const options = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  const importCustomersPath = `${CUSTOMER_IMPORT}?cfdi_seal_version=${payload.version}`;

  return dispatch =>
    axios.post(importCustomersPath, payload.formData, options).then(
      data =>
        new Consequence({
          dispatch,
          payload: {
            data
          },
          eventTypes: {
            success: NEW_IMPORT_CLIENTS,
            error: 'ERROR'
          }
        })
    );
} // END importContractXls

/**
 * Obtiene las actividades recientes de un determinado cliente
 * @param {string}    uuid   Identificador del cliente
 * @param {object}    params Filtros del servicio
 * @return {function}        Acción de redux
 */
export function getCustomerActivity(uuid, params) {
  return dispatch =>
    axios.get(parseUrl(CUSTOMER_ACTIVITY, { uuid }, params)).then(res => {
      const activities = get(res, 'data.data');
      return new Consequence({
        dispatch,
        payload: { data: activities },
        eventTypes: { success: NEW_CUSTOMER_ACTIVITY, error: 'ERROR' }
      });
    });
}

export function updateCustomerActivity(newActivities) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_ACTIVITY,
        payload: newActivities
      })
    );
} // END updateCustomerActivity

export function resetSearching() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_SEARCHING,
        payload: false
      })
    );
} // END updateLoadingTable

export function updateLoadingTable(loadingTable) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_LOADING_TABLE,
        payload: loadingTable
      })
    );
} // END updateLoadingTable

export function getCustomerInvoiceVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Tipo: {
      cfdi: false,
      invoice: false
    },
    Estado: {
      late_payment: false,
      current: false,
      paid: false,
      cancel: false
    },
    Origen: {
      ar: false,
      bar: false,
      xml: false,
      sat: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_INVOICES_FILTERS,
        payload: { filters, updateTable, searching }
      }),
      dispatch({
        type: NEW_VALUES,
        payload: initialValuesTags
      })
    );
} // END getContractsVisibilityFilters

export function getCustomerPaymentsVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Estado: {
      confirmed: false,
      pending: false,
      reject: false,
      cancel: false
    },
    Manual: {
      ar: false,
      xml: false,
      bar: false
    },
    Pasarela: {
      fiserv: false,
      oxxo_public: false,
      stp: false,
      stripe: false,
      conekta: false,
      spei: false,
      kushki: false,
      payfac: false,
      bank_sync: false
    },
    Comprobante: {
      1: false,
      2: false,
      3: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_PAYMENTS_FILTERS,
        payload: { filters, updateTable, searching }
      }),
      dispatch({
        type: NEW_VALUES_PAYMENTS,
        payload: initialValuesTags
      })
    );
} // END getContractsVisibilityFilters

export function getCustomerContractsVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Estado: {
      active: false,
      inactive: false,
      no_ended: false
    },
    Recurrencia: {
      monthly: false,
      weekly: false
    },
    Domiciliado: {
      1: false,
      2: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });

  return dispatch =>
    Promise.resolve(
      dispatch({ type: NEW_CUSTOMER_CONTRACTS_FILTERS, payload: { filters, updateTable, searching } }),
      dispatch({
        type: NEW_VALUES_CONTRACTS,
        payload: initialValuesTags
      })
    );
} // END getContractsVisibilityFilters

export function getCustomerCreditNotesVisibilityFilters(filters, updateTable = true, searching = true) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_CREDIT_NOTES_FILTERS,
        payload: { filters, updateTable, searching }
      })
    );
} // END getContractsVisibilityFilters

export function getCustomerNotesVisibilityFilters(filters, updateTable = true, searching = true) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_CUSTOMER_NOTES_FILTERS,
        payload: { filters, updateTable, searching }
      })
    );
} // END getContractsVisibilityFilters

export function getCustomerPaymentsV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${PAYMENT_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CUSTOMER_PAYMENTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_PAYMENTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getPaymentsV2

export function getCustomerContractsV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${CONTRACT_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CUSTOMER_CONTRACTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getContractsV2

export function getCustomerCreditNotesV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${CREDIT_NOTE_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CUSTOMER_CREDIT_NOTES, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}
export function getCustomerSucursalAll(clientId,params) {
  return dispatch =>
    axios
      .get(parseUrl(CUSTOMER_RELATION, { clientId },params))
      .then(res => thunkHandler(dispatch, get(res, 'data'), CUSTOMER_SUCURSAL_ALL, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}
export function requestCustomerSucursal(payload,clientId) {
  return dispatch =>
    axios.post(CUSTOMER_RELATION_BASE, payload).then(res => {
      getCustomerSucursalAll(clientId)(dispatch);
      new Consequence({
        dispatch,
        payload: { data: res },
        eventTypes: { success: NEW_CUSTOMER_SUCURSAL, error: 'ERROR' }
      });
    });
}
export function deleteCustomerSucursal(customerRelationId, clientId) {
  return dispatch =>
    axios
      .delete(parseUrl(CUSTOMER_RELATION_BYID, { customerRelationId }))
      .then(() => {
        getCustomerSucursalAll(clientId)(dispatch);
        dispatch({ type: DELETE_CUSTOMER_SUCURSAL, payload: null });
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} //END deleteConektaIntegration

export function getCustomerSucursalByid(customerRelationId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      axios
        .get(parseUrl(CUSTOMER_RELATION_BYID, { customerRelationId }))
        .then(res => {
          const data = get(res, 'data');
          thunkHandler(dispatch, data, CUSTOMER_SUCURSAL_BYID, 'ERROR');
          resolve(data);
        })
        .catch(error => {
          thunkErrorHanlder(error, dispatch, 'ERROR');
          reject(error);
        });
    });
  };
}
export function updateCustomerSucursal(payload, customerRelationId,clientId) {
  return dispatch =>
    axios.put(CUSTOMER_RELATION_BYID.replace(':customerRelationId', customerRelationId), payload).then(res => {
      getCustomerSucursalAll(clientId)(dispatch);
      return new Consequence({
        dispatch,
        payload: { data: get(res, 'data.data') },
        eventTypes: { success: UPDATE_CUSTOMER_SUCURSAL, error: 'ERROR' }
      });
    });
  }
export function getCustomerNotes(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = parseUrl(CUSTOMER_NOTES, { uuid: get(personalized, 'customer_id') });

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => {
        return thunkHandler(dispatch, get(res, 'data.data.data').reverse(), NEW_CUSTOMER_NOTES, 'ERROR', res);
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getContractsV2

/**
 * Obtiene los recordatorios por cliente
 * @param {string}    uuid Identificador del cliente
 * @return {function}      Acción de redux
 */
export function getCustomerReminders(uuid, params, cancelToken) {
  if (typeof uuid !== 'string' || !isPlainObject(params)) return;

  const page = get(params, 'page', 1);
  const config = cancelToken ? { cancelToken: cancelToken.token } : {};

  return dispatch =>
    axios.get(parseUrl(CUSTOMER_REMINDERS, { uuid }, { page }), config).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data') },
          eventTypes: { success: NEW_CUSTOMER_REMINDERS, error: 'ERROR' }
        })
    );
} // END getCustomerReminders

/**
 * Obtiene los rfc´s asociados por cliente
 * @param  {string}    uuid Identificador del cliente
 * @return {function}  Acción de redux
 */
export function getCustomerTaxes(uuid, params, cancelToken) {
  if (typeof uuid !== 'string' || !isPlainObject(params)) return;

  const page = get(params, 'page', 1);
  const config = cancelToken ? { cancelToken: cancelToken.token } : {};

  return dispatch =>
    axios.get(parseUrl(CUSTOMER_TAXES, { uuid }, { page }), config).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: { taxes: get(res, 'data.data'), pagination: get(res, 'data.paginate') } },
          eventTypes: { success: NEW_CUSTOMER_TAXES, error: 'ERROR' }
        })
    );
} // END getCustomerTaxes

export function importBranchOffices(payload) {
  return axios.post(BRANCH_ASSIGNMENT_IMPORT, payload, { headers: { 'content-type': 'multipart/form-data' } });
}


// WEBPACK FOOTER //
// ./src/redux/actions/customerActions.js